//src/components/sellProperty.contstants.js
import { MdSell } from 'react-icons/md';
import { RiHomeSmileLine } from 'react-icons/ri';

export const STEPS = ['Informasi Pemilik', 'Detail Properti', 'Harga, Fitur & Lokasi Terdekat', 'Konfirmasi'];

export const LISTING_TYPE = [
    {
        value: 'for_sale',
        label: 'Dijual',
        icon: MdSell,
    },
    {
        value: 'for_rent',
        label: 'Disewakan',
        icon: RiHomeSmileLine,
    },
];

export const RENT_DURATION = [
    { value: 'monthly', label: 'Per Bulan' },
    { value: 'yearly', label: 'Per Tahun' },
];

export const FURNISHING_STATUS_OPTIONS = [
    { value: '', label: 'Pilih kondisi perabotan' },
    { value: 'unfurnished', label: 'Unfurnished' },
    { value: 'semi_furnished', label: 'Semi Furnished' },
    { value: 'fully_furnished', label: 'Fully Furnished' },
];

export const BUILDING_CONDITION_OPTIONS = [
    { value: '', label: 'Pilih kondisi bangunan' },
    { value: 'baru', label: 'Baru' },
    { value: 'sangat_bagus', label: 'Sangat Bagus' },
    { value: 'bagus', label: 'Bagus' },
    { value: 'cukup', label: 'Cukup' },
    { value: 'perlu_renovasi_ringan', label: 'Perlu Renovasi Ringan' },
    { value: 'perlu_renovasi_berat', label: 'Perlu Renovasi Berat' },
];

export const BUILDING_ORIENTATION_OPTIONS = [
    { value: '', label: 'Pilih orientasi bangunan' },
    { value: 'utara', label: 'Utara' },
    { value: 'selatan', label: 'Selatan' },
    { value: 'timur', label: 'Timur' },
    { value: 'barat', label: 'Barat' },
    { value: 'timur_laut', label: 'Timur Laut' },
    { value: 'tenggara', label: 'Tenggara' },
    { value: 'barat_laut', label: 'Barat Laut' },
    { value: 'barat_daya', label: 'Barat Daya' },
    { value: 'hook', label: 'Hook' },
];

export const NEARBY_CATEGORY_OPTIONS = [
    { value: '', label: 'Pilih kategori' },
    { value: 'Pendidikan', label: 'Pendidikan' },
    { value: 'Kesehatan', label: 'Kesehatan' },
    { value: 'Transportasi', label: 'Transportasi' },
    { value: 'Perbelanjaan', label: 'Perbelanjaan' },
    { value: 'Kuliner', label: 'Kuliner' },
    { value: 'Ibadah', label: 'Ibadah' },
    { value: 'Rekreasi', label: 'Rekreasi' },
    { value: 'Perkantoran', label: 'Perkantoran' },
    { value: 'Lainnya', label: 'Lainnya' },
];

export const SELL_PROPERTY_TIPS = [
    'Lokasi Strategis',
    'Bebas Banjir',
    'Sangat Cocok untuk Investasi',
    'Nyaman dan Asri',
    'Lokasi Bagus',
    'Jarang Ada',
    'Super Strategis',
    'Harga Terbaik',
    'Fasilitas Terbaik',
    'Lingkungan Nyaman',
    'Lingkungan Asri',
    'Sangat Strategis',
    'Siap Pakai',
];

export const createEmptyNearbyPlace = (sortOrder = 0) => ({
    category: '',
    name: '',
    address: '',
    distance_km: '',
    sort_order: sortOrder,
});

export const initialForm = {
    ownerName: '',
    ownerPhone: '',
    ownerEmail: '',
    property_type_id: '',
    certificate_type_id: '',
    status: '',
    sale_rent_duration: 'yearly',
    title: '',
    description: '',
    address: '',
    location: '',
    province: '',
    city: '',
    district: '',
    village: '',
    land_area: '',
    building_area: '',
    bedrooms: '',
    bathrooms: '',
    floors: '',
    construction_year: '',
    renovation_year: '',
    garage_count: '',
    carport_count: '',
    furnishing_status: '',
    electric_power: '',
    building_orientation: '',
    building_condition: '',
    price: '',
    feature_ids: [],
    nearby_places: [],
};
